import * as S from "./styles.ts";
import { forwardRef, ReactElement, Ref } from "react";

export type TDropdownOption = {
  label: string;
  key?: string | number | boolean | null | undefined;
  disabled?: boolean;
  render?: ReactElement;
};

interface IDropdownItemProps extends TDropdownOption {
  onSelect: () => void;
  selected: boolean;
  setIsOpen: (val: boolean) => void;
}

interface IDropdownProps {
  options: TDropdownOption[];
  selected?: string | number;
  onChange?: (val: TDropdownOption["key"]) => void;
  setIsOpen: (val: boolean) => void;
}

const DropdownItem = ({
                        label,
                        onSelect,
                        selected,
                        disabled,
                        render,
                        setIsOpen,
                        ref,
                      }: IDropdownItemProps & {
  ref?: Ref<any>;
}) => {
  return (
    <S.DropdownItem
      onClick={(e) => {
        e.stopPropagation();
        onSelect();
        setIsOpen(false);
      }}
      ref={ref}
      tabIndex={disabled ? -1 : 0}
      $disabled={disabled || false}
      $selected={selected}
    >
      {render || label}
    </S.DropdownItem>
  );
};

const Dropdown = forwardRef(
  ({ options, selected, onChange, setIsOpen }: IDropdownProps, ref: any) => {
    return (
      <S.DropdownWrapper>
        <S.DropdownContainer tabIndex={0}>
          {options.length > 0 ? (
            options.map(({ key, ...option }, i) => (
              <DropdownItem
                key={`${key}${i}`}
                label={option.label}
                onSelect={() => onChange && onChange(key as any)}
                setIsOpen={setIsOpen}
                ref={i === 0 ? ref : undefined}
                selected={key === selected}
                render={option.render}
                disabled={option.disabled}
              />
            ))
          ) : (
            <S.DropdownItem $disabled>No results found</S.DropdownItem>
          )}
        </S.DropdownContainer>
      </S.DropdownWrapper>
    );
  }
);

export default Dropdown;
